import "./TurnoConfirmado.css";
import { getDiaStrTurno } from "../../../../global/utils/diasTurno";
import HeaderModal from "../../Genericos/headerModal/headerModal";
import camelize from "global/utils/camelize";
import TagManager from "react-gtm-module";
import { useEffect } from "react";

const TurnoConfirmado = ({
  titulo,
  dissmiss,
  fecha,
  hora,
  medico,
  centro,
  ubicacion,
  tipoTurno,
  videoConsulta,
}) => {
  useEffect(() => {
    let event =
      tipoTurno?.tipo === "LABO"
        ? "Laboratorio"
        : tipoTurno?.circuito === "TOMO"
        ? "Tomografía"
        : tipoTurno?.circuito === "RMN"
        ? "Resonancia"
        : "";

    if (event !== "") {
      TagManager.dataLayer({
        dataLayer: {
          event,
        },
      });
    }
  }, []);

  return (
    <>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} />
      <div className="ptur-turnoConfirmado-body">
        <div className="ptur-turnoConfirmado-tildeTxt">
          <div className="ptur-turnoConfirmado-tilde">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="146"
              height="146"
              viewBox="0 0 100 100"
            >
              <circle
                className="ptur-circle-turnoConfirmado"
                cx="50"
                cy="50"
                r="45"
              ></circle>
              <path
                className="ptur-check-turnoConfirmado"
                d="M25 50 L40 65 L75 30"
              ></path>
            </svg>
          </div>
          <div>
            {videoConsulta ? (
              <p className="rb22t">Su turno de videoconsulta</p>
            ) : (
              <p className="rb22t">
                Su turno {tipoTurno?.tipo === "CONSULTA" ? "con" : "para"}{" "}
                <span className="rb22b">
                  {tipoTurno?.tipo === "LABO"
                    ? "Laboratorio"
                    : tipoTurno?.circuito === "TOMO"
                    ? "Tomografía"
                    : tipoTurno?.circuito === "RMN"
                    ? "Resonancia"
                    : camelize(tipoTurno?.estudio)}
                </span>
              </p>
            )}
            <p className="rb22t">se ha confirmado con éxito</p>
          </div>
        </div>
        <div className="ptur-turnoConfirmado-txtContainer">
          <div className="ptur-turnoConfirmado-fecha c-primary rb16b">
            {getDiaStrTurno(fecha)}
            {getDiaStrTurno(fecha, true)} {hora} hs
          </div>
          <div className="ptur-turnoConfirmado-datosTurno">
            <p className="rb16b">{medico}</p>
            <p>{centro}</p>
            <p>{ubicacion}</p>
          </div>
        </div>
        <div className="ptur-turnoConfirmado-btnContainer">
          <button
            className="ptur-turnoConfirmado-btn c-latex30 bgc-white rb18l"
            onClick={dissmiss}
          >
            Finalizar
          </button>
        </div>
      </div>
    </>
  );
};

export default TurnoConfirmado;
